import { existsFilter } from '@iotv/core-services';
import { isValidAttributeKeyDefinitionOfType } from '@iotv/iotv-v3-types';
import { SupportedPayloadDefinitions } from '@iotv/lfc-devices';
import { resolvePayloadDefinitions } from '@iotv/payload-definition';
export const getDownlinkDefinitionAttributes = ({ device }) => {
    let downLinkPayloadAttributes = undefined;
    let downLinkRangeLimits = undefined;
    let payloadDefintionNames = undefined;
    let correspondingUplinkAttributeMap = null;
    if (device) {
        const resolved = resolvePayloadDefinitions({ device, port: null });
        payloadDefintionNames = resolved.map((def) => def.name).filter(existsFilter);
        const downlink = resolved[0]?.downlink;
        if (downlink) {
            downLinkPayloadAttributes = downlink.downLinkPayloadAttributes;
            downLinkRangeLimits = downlink.downLinkRangeLimits;
            correspondingUplinkAttributeMap = downlink.correspondingUplinkAttributeMap;
        }
        console.log(`Resolved:`, { payloadDefintionNames, downLinkPayloadAttributes, downLinkRangeLimits, correspondingUplinkAttributeMap });
    }
    const attributes = downLinkPayloadAttributes ??
        SupportedPayloadDefinitions.GenericDevicePayloadDefinition.downlink.downLinkPayloadAttributes;
    const rangeLimits = downLinkRangeLimits ?? SupportedPayloadDefinitions.GenericDevicePayloadDefinition.downlink.downLinkRangeLimits;
    return { attributes, rangeLimits, payloadDefintionNames, correspondingUplinkAttributeMap };
};
export const getValidRangeText = (attributeValidation) => {
    let validRangeText = '';
    try {
        const { range } = isValidAttributeKeyDefinitionOfType(attributeValidation, 'number') ? attributeValidation : {};
        if (range) {
            const { min, max } = range;
            validRangeText = `(${min} - ${max})`;
        }
    }
    catch (error) {
        console.error('Error in getValidRangeText:', error);
    }
    return validRangeText;
};
